import React, { useRef, useState, useEffect } from "react";
import Select from "react-select";
import { customSelSearch } from "../utils/configs";

const CustomSelect = (props) => {
  const {
    options,
    placeHolder,
    onChange,
    value,
    onMenuClose,
    onMenuOpen,
    width,
    isDisabled,
    isClearable,
    isSearchable,
    autoWidth,
    rightMargin
  } = props;

  const selectRef = useRef(null);
  const [widthAuto, setWidthAuto] = useState("100%");
const marginStyle = rightMargin ? { marginRight: rightMargin } : {};
  useEffect(() => {
    if (autoWidth) {
      const handleResize = () => {
        if (selectRef.current) {
          setWidthAuto(selectRef.current.offsetWidth);
        }
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [autoWidth]);

  return (
    <div ref={selectRef} className="selectWrapper" style={{ width: "100%", ...marginStyle }}>
      <Select
        {...(value !== undefined && { value })}
        defaultValue={value || null}
        onMenuOpen={onMenuOpen || null}
        onMenuClose={onMenuClose || null}
        isDisabled={isDisabled || false}
        options={options}
        menuPortalTarget={null} 
        menuShouldBlockScroll={false}             
        menuPosition="absolute"               
        menuShouldScrollIntoView={false} 
        styles={{
          ...customSelSearch,
          control: (base) => ({
            ...base,
            backgroundColor: "#162E3E",
            width: autoWidth ? widthAuto : width || "13rem",
            boxShadow: "none",
            marginRight: rightMargin || "0px",  
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        placeholder={placeHolder}
        onChange={onChange}
        isClearable={isClearable ?? true}
        isSearchable={isSearchable ?? true}
      />
    </div>
  );
};

export default CustomSelect;
